export const getCrashTransport = (data) => {
  const transport = data.timelineEvents.find(
    (transport) => transport.timelineEvent.eventId === data.transportEventId
  );
  return transport;
};
